import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SectionContainer from '../ui/SectionContainer';

/**
 * ErrorMessage - エラー表示コンポーネント
 */
function ErrorMessage({ error }) {
    if (!error) return null;
    
    return (
        <SectionContainer>
            <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                backgroundColor: 'rgba(211, 47, 47, 0.05)',
                borderRadius: '6px',
                p: 2
            }}>
                <ErrorOutlineIcon color="error" sx={{ mr: 1 }} />
                <Typography color="error" align="center" variant="body1">
                    {error}
                </Typography>
            </Box>
        </SectionContainer>
    );
}

ErrorMessage.propTypes = {
    error: PropTypes.string,
};

export default ErrorMessage;
